<nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
  <div class="container pl-md-0">
    <span class="navbar-brand">
      <img alt="logo" class="d-inline-block align-middle img-fluid" src="assets/images/logo.png" />
    </span>

    <button (click)="toggleNavbar()" class="navbar-toggler" type="button">
      <fa-icon [icon]="['fas', navbarOpen ? 'times' : 'bars']"></fa-icon>
    </button>
    <div [ngClass]="{ 'show': navbarOpen }" class="collapse navbar-collapse">
      @if ($authenticated | async; as authenticated) {
      <ul class="navbar-nav ml-auto">
        @if (authenticated) {
        <li class="nav-item pl-md-0 pl-3">
          <a (click)="$event.stopPropagation();logout()" class="nav-link" href="/">
            <fa-icon [icon]="['fas', 'sign-out-alt']" class="pr-2"></fa-icon>
            {{'header.menu.logout' | translate}}</a
          >
        </li>
        } @if (!authenticated) {
        <li class="nav-item pl-md-0 pl-3">
          <a class="nav-link" href="{{loginLink}}">
            <fa-icon [icon]="['fas', 'sign-in-alt']" class="pr-2"></fa-icon>
            {{'header.menu.login' | translate}}</a
          >
        </li>
        }
      </ul>
      }
    </div>
  </div>
</nav>
